
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import React, {useContext, useEffect, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import TextArea from "../input/TextArea";
import {ValidationContext} from "../contexts/ValidationContext";
import {ApiContext} from "../contexts/ApiContext";
import {useAuth} from "../../providers/authProvider";

function EditAdultModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        rowData: any,
        admin?: boolean,
        locked?: boolean,
    }
) {
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)
    const {Url } = useContext(ApiContext)
    const { token } = useAuth();
    const [FirstName, setFirstName] = useState('')
    const [LastName, setLastName] = useState('')
    const [Info, setInfo] = useState('')
    const [AdultID, setAdultID] = useState('')
    const [admin, setAdmin] = useState(false)
    const [message, setMessage] = useState('')

    let patchUrl: string;
    if (admin){
        patchUrl = Url + 'admin/adults'
    }else{
        patchUrl = Url + 'user/adults'
    }

    useEffect(() => {
        if (!props.rowData) return;
        setFirstName(props.rowData.FirstName)
        setLastName(props.rowData.LastName)
        setInfo(props.rowData.Info)
        setAdultID(props.rowData.ID)
        if (props.admin){
            setAdmin(true)
        }

    }, [props.admin, props.rowData]);

    function editAdult() {
        if (FirstName === '' || LastName === '' || Info === '' ){
            setMessage('Nog niet alle  velden zijn ingevuld.')
            return
        }
        editAdultVisitorPage()
    }

    function editAdultVisitorPage(){
        const localSetMessage = setMessage;
        const localSetFirstName = setFirstName;
        const localSetLastName = setLastName;
        const localSetInfo = setInfo;
        const localSetOpenModal = props.setOpenModal;

        (localSetMessage as any)("Bezig met opslaan...")
        fetch(patchUrl, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: AdultID,
                FirstName : FirstName,
                LastName: LastName,
                Info: Info,
            }),
        }).then((res: any) => {
            if (res.status === 200) {
                //Saving successfully.
                (localSetMessage as any)("");
                (localSetFirstName as any)('');
                (localSetLastName as any)('');
                (localSetInfo as any)('');
                (localSetOpenModal as any)(false);
            } else {
                //Saving failed
                (localSetMessage as any)("Het opslaan is mislukt, neem contact op.")
            }
        }).catch((err: any) => {
             (localSetMessage as any)("Er is een fout opgetreden.")
        })
    }
    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title={`Bewerk ${FirstName} ${LastName}`}
            footer={
                <>
                    <DefaultButton onClick={editAdult} content="Wijzigen" disabled={props.locked}/>
                    <DefaultButton onClick={() => props.setOpenModal(false)} content="Annuleren" />
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Geeft de gegevens van de volwassene persoon op en klik op wijzigen. Alle velden zijn verplicht.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput labelName="Voornaam"
                       inputName="firstName"
                       onChange={(e) => setFirstName(e.target.value)}
                       value={FirstName}
                       placeholder="Voornaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextInput labelName="Achternaam"
                       inputName="lastName"
                       onChange={(e) => setLastName(e.target.value)}
                       value={LastName}
                       placeholder="Achternaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />

            <TextArea labelName="Info"
                      inputName="info"
                      onChange={(e) => setInfo(e.target.value)}
                      value={Info}
                      placeholder=""
                      rows={4}
                      disabled={props.locked}
            />
        </BaseModal>
    );
}
export default EditAdultModal
